<template>
    <div v-if="estrutura">
        <div v-if="!properties" class="form-label toast-header header-title"> Geral
        </div>

        <b-row v-for="(prop, chave, index) in propsVisiveis(estrutura)" :key="index" align-v="end">

            <b-col md="4" sm="4" v-if="prop && prop.type" class="text-left">

                <label class="form-label custom-label">{{ chave }}&nbsp;
                </label>

                <ClicHintInterno
                    v-if="(estrutura[chave] && estrutura[chave].documentation) || (estrutura.config && estrutura.config.documentation && estrutura.config.documentation[chave])"
                    :cp="{
        props: {
            ...getDocumentationByProp(estrutura, chave)
        }
    }" />
            </b-col>

            <b-col sm="12" md="8"
                v-if="prop && prop.component && (prop.component.name == 'input' || prop.component.name === '') && prop.type != 'boolean'">
                <div class="form-group">
                    <b-form-input v-if="prop && prop.type != 'number' && prop.type != 'integer'"
                        :placeholder="lodash.get(prop, 'default', '').toString()" class="form-control"
                        v-model="props[chave]" v-on:change="updateChange(chave, props[chave])"
                        :disabled="lodash.get(prop, 'disabled', false)"  autocomplete="off"/>

                    <b-form-input v-if="prop && prop.type == 'number' || prop.type == 'integer'"
                        :placeholder="lodash.get(prop, 'default', '').toString()" type="number" class="form-control"
                        v-model="props[chave]" v-on:change="updateChange(chave, props[chave])"
                        :disabled="lodash.get(prop, 'disabled', false)" autocomplete="off" />

                </div>
            </b-col>

            <b-col sm="8" v-if="prop && prop.component && prop.component.name == 'code'">
                <b-input-group>
                    <b-button v-b-modal="chave" variant="outline-primary"
                        class="btn-modal-code-editor">{{ estrutura[chave].value != undefined || props[chave] != undefined
        ? 'Editar' : 'Novo' }}
                    </b-button>

                </b-input-group>
                <CodeEditor :code="props[chave] != undefined ? props[chave] : estrutura[chave].value" :chave="chave"
                    :parentId="parentId"
                    v-on:changeValueCodeEditor="(newValue) => { updateChange(chave, newValue); props[chave] = newValue }" />
            </b-col>

            <b-col sm="8"
                v-if="prop && prop.component && (prop.component.name == 'select' || prop.component.name == 'multiselect')">
                <Multiselect cols="12" 
                    :value="formatValueForSelector(prop, props[chave])"
                    :placeholder="lodash.get(prop, 'default', '').toString()"
                    :options="lodash.get(prop, 'component.values', [])"
                    :label="lodash.get(prop, 'component.labels', undefined)"
                    :track-by="lodash.get(prop, 'component.trackBy', undefined)"
                    :show-icon-preview="lodash.get(prop, 'component.showIconPreview', false)"
                    :multiple="prop.component.name == 'select' ? false : true"
                    v-on:changeValueMultiselect="(newValue) => props[chave] = formatSelectorValueForStorage(prop, newValue)" />
            </b-col>

            <b-col sm="8" v-if="prop && prop.type && prop.type == 'boolean'">
                <b-form-checkbox v-model="props[chave]" name="check-button"
                    v-on:change="updateChange(chave, props[chave])" switch
                    :disabled="lodash.get(prop, 'disabled', false)" />

            </b-col>

            <b-col sm="12" v-if="props && typeof props[chave] == 'object'">
                <div class="form-label toast-header header-title"> {{ chave }} </div>
                <Propriedades :parentId="parentId" :structure="prop" :properties="props[chave]" />
            </b-col>

            <b-col sm="12" v-if="props && typeof props[chave] == 'object' && prop.containerFW">
                <div class="form-label toast-header header-title"> Container </div>
                <Propriedades :parentId="parentId" :structure="prop.containerFW" :properties="props[chave]" />
            </b-col>

            <b-col sm="12" v-if="props && typeof props[chave] == 'object' && prop.iconFW">
                <div class="form-label toast-header header-title"> Ícone </div>
                <Propriedades :parentId="parentId" :structure="prop.iconFW" :properties="props[chave]" />
            </b-col>


            <b-col sm="12" v-if="props && typeof props[chave] == 'object' && prop.imageFW">
                <div class="form-label toast-header header-title"> Imagem </div>
                <Propriedades :parentId="parentId" :structure="prop.imageFW" :properties="props[chave]" />
            </b-col>

            <b-col sm="12" v-if="props && typeof props[chave] == 'object' && prop.hintFW">
                <div class="form-label toast-header header-title"> Hint </div>
                <Propriedades :parentId="parentId" :structure="prop.hintFW" :properties="props[chave]" />
            </b-col>

            <b-col sm="12" v-if="props && typeof props[chave] == 'object' && prop.badgeFW">
                <div class="form-label toast-header header-title"> Ícone </div>
                <Propriedades :parentId="parentId" :structure="prop.badgeFW" :properties="props[chave]" />
            </b-col>


        </b-row>
    </div>
</template>


<script>
import CodeEditor from './CodeEditor.vue'
import Multiselect from './Multiselect.vue'
import { BRow, BCol, BFormInput, BInputGroup, BButton, BFormCheckbox } from 'bootstrap-vue';
export default {
    name: 'Propriedades',
    components: {
        CodeEditor,
        Multiselect,
        BRow, BCol, BFormInput, BInputGroup, BButton, BFormCheckbox,
    },

    data() {
        return {
            estrutura: {},
            props: {},
        }
    },
    methods: {

        // Props com visible: false no modelo continuam valendo no componente, mas não aparecem no editor (sem a chave:
        // visível). Comparação estrita: num grupo de props (containerFW...), 'visible' é a definição da prop, não false
        propsVisiveis(estrutura) {
            return Object.fromEntries(
                Object.entries(estrutura || {}).filter(([, prop]) => !(prop && prop.visible === false))
            );
        },

        getDocumentationByProp(estrutura, chave) {
            try {
                if (this.lodash.has(estrutura, `[${chave}].documentation`)) {
                    return estrutura[chave].documentation
                } else if (this.lodash.has(estrutura, `config.documentation[${chave}]`)) {
                    return estrutura.config.documentation[chave]
                } else {
                    return {};
                }
            } catch (e) {
                console.error("Ocorreu um erro na função 'getDocumentationByProp' - Criador de telas. Detalhes:", e);
            }
        },


        formatSelectorValueForStorage(prop, value) {
            const trackBy = this.lodash.get(prop, 'component.trackBy');

            if (prop?.component?.name === 'multiselect') {
                const values = Array.isArray(value) ? value : [];

                if (trackBy) {
                    return values
                        .map((item) => this.lodash.get(item, trackBy))
                        .filter((item) => item !== undefined && item !== null && item !== '')
                        .join(' ');
                }

                return values.join(' ');
            }

            if (trackBy && value && typeof value === 'object') {
                return this.lodash.get(value, trackBy);
            }

            return value;
        },

        formatValueForSelector(prop, value) {
            const options = this.lodash.get(prop, 'component.values', []);
            const trackBy = this.lodash.get(prop, 'component.trackBy');
            const isMultiple = this.lodash.get(prop, 'component.name') === 'multiselect';

            if (isMultiple) {
                if (!value || value === '') {
                    return [];
                }

                const values = Array.isArray(value) ? value : String(value).split(' ');

                if (trackBy) {
                    return values
                        .map((item) => options.find((option) => String(this.lodash.get(option, trackBy)) === String(item)))
                        .filter(Boolean);
                }

                return values;
            }

            if (value === undefined || value === null || value === '') {
                return null;
            }

            if (trackBy) {
                return options.find((option) => String(this.lodash.get(option, trackBy)) === String(value)) || null;
            }

            return value;
        },

        populateStructure() {
            if (this.structure) {
                this.estrutura = this.structure;
            }

            if (this.estrutura && this.properties) {
                for (let key in this.estrutura) {
                    if (!this.properties[key] && this.properties[key] == undefined) {
                        if (this.estrutura[key] && this.estrutura[key].default && this.estrutura[key].default != undefined) {
                            this.properties[key] = this.estrutura[key].default
                        }
                    }

                }
            }

            if (this.properties) {
                for (let key in this.properties) {
                    if (typeof this.properties[key] == 'object') {
                        this.properties[key] = JSON.stringify(this.properties[key]);
                    }
                }

                this.props = this.properties;
            }
        },

        updateChange(chave, valor) {
            try {
                this.estrutura[chave].value = valor;
                this.$forceUpdate();
            } catch (e) {
                console.error("[Propriedades | Criador de telas] Ocorreu um erro na execução do método 'updateChange'", e);
            }

        },

        atualizarConsulta(estrutura, propriedades) {
            this.estrutura = this.clonarEstrutura(estrutura);
            this.props = propriedades;
            
        },
        
        clonarEstrutura(estruturaRecebida) {
            let estrutura = this.lodash.clone(estruturaRecebida);

            return estrutura;
        }
    },

    props: {
        structure: {
            type: Object
        },
        properties: {
            type: Object
        },
        parentId: {
            type: String
        },
    },

    mounted() {
        this.populateStructure();
    },

    updated() {
        this.populateStructure();
    }

}

</script>
<style scoped>
div {
    padding-top: 5px !important;
}

div .toast-header {
    text-transform: capitalize !important;
}

.btn-modal-code-editor {
    height: 35px;
    justify-content: center;
    width: 100px;
    margin-left: 5px;
    margin-top: -2px;
    padding: 0px
}

.header-title {
    text-align: center;
    font-weight: 900;
}

.custom-label {
    padding-left: 3vw;
    font-size: 13px;
    font-weight: 500 !important;
    color: rgb(116, 116, 116)
}
</style>
